import { Toast, Tooltip } from './_bootstrap';

(() => {
	//* Tooltip initialization, remove it if not necessary
	for (const tooltipElement of document.querySelectorAll(
		'[data-toggle="tooltip"]',
	)) {
		new Tooltip(tooltipElement);
	}

	//* Toast initialization, remove it if not necessary
	for (const toastElement of document.querySelectorAll(".toast")) {
		new Toast(toastElement);
	}
  Drupal.behaviors.ep5Carousel = {
    attach: function (context) {
      // console.log('Hello Carousel');
      // /*
      //     Carousel
      // */
      // jQuery('.carousel').on('slide.bs.carousel', function (e) {
      //   /*
      //       CC 2.0 License Iatek LLC 2018 - Attribution required
      //   */
      //   const $e = jQuery(e.relatedTarget);
      //   const idx = $e.index();
      //   const jqCarItem = jQuery('.carousel-item');
      //   const totalItems = jqCarItem.length;
      //   // const itemsPerSlide = 5;
      //   const itemsPerSlide = totalItems -3;
      // //
      //   console.log("totalitems:" + totalItems);
      //   console.log("itemsPerSlide:" + itemsPerSlide);
      //   console.log("e:" + e);
      //   console.log("idx:" + idx);
      // //
      //   if (idx >= totalItems-(itemsPerSlide-1)) {
      //     const it = itemsPerSlide - (totalItems - idx);
      //     console.log("it:" + it);
      //     for (let i=0; i<it; i++) {
      //       // append slides to end
      //       if (e.direction==="left") {
      //         jqCarItem.eq(i).appendTo('.carousel-inner');
      //       }
      //       else {
      //         jqCarItem.eq(0).appendTo('.carousel-inner');
      //       }
      //     }
      //   }
      // });
    }
  }
})(jQuery, Drupal);
